import React from "react";

const Agreement = () => {

  return (

    <>

      <div

        style={{

          background: "rgba(255, 255, 255, 0.3)",

          backdropFilter: "blur(10px)",

          WebkitBackdropFilter: "blur(10px)",

          borderRadius: "0.5rem",

          padding: "2rem",

          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",

          width: "100%",

          maxWidth: "80%",

          margin: "0 auto",

          maxHeight: "80vh",

          overflowY: "auto",

          color: "whitesmoke",

          zIndex: 1,

          marginTop: "10vh",

        }}

      >

        <h2

          style={{

            fontSize: "1.5rem",

            fontWeight: "bold",

            marginBottom: "1rem",

            textAlign: "center",

          }}

        >

          SERVICE AGREEMENT

        </h2>

        <p style={{ marginBottom: "1rem" }}>

          This Service Agreement (the "Agreement") is made and entered into

          as of the date of submission by the undersigned client (hereinafter

          referred to as "Client") and KS Quantitative, a subsidiary of KS

          Market Ltd, a corporation duly registered and existing under the laws

          of the Federal Republic of Nigeria, with Corporate Affairs Commission

          Registration Number 1866331 (hereinafter referred to as "KS Quantitative").

        </p>

        <h3 style={{ fontWeight: "bold" }}>1. About KS Quantitative:</h3>

        <p>

          KS Quantitative is a leading financial technology provider specializing in

          algorithmic trading strategies and quantitative finance solutions. We partner

          with licensed brokerage firms to provide Portfolio Asset Management (PAM)

          and Multi-Account Management (MAM) services to institutional and retail clients.

        </p>

        <h3 style={{ fontWeight: "bold" }}>2. Service Framework:</h3>

        <p>

          KS Quantitative provides a comprehensive range of financial services including:

          quantitative trading strategies, algorithmic solutions, fund management,

          investment consulting, education and training, and quantitative research

          and development. Our trading services are delivered through certified

          brokerage partners. All investment terms, conditions, fees, and regulatory

          compliance are governed by the specific brokerage agreement that will be

          provided to you by your assigned brokerage partner.

        </p>

        <h3 style={{ fontWeight: "bold" }}>3. Service Delivery Model:</h3>

        <p>

          KS Quantitative provides services directly to clients and through strategic

          partnerships with regulated financial institutions where applicable. The specific

          terms and conditions for each service, including but not limited to:

        </p>

        <ul style={{ marginLeft: "1rem", marginBottom: "1rem" }}>

          <li>Service fees and subscription charges</li>

          <li>Performance fees for managed accounts</li>

          <li>Payment and billing procedures</li>

          <li>Service delivery timelines and access</li>

          <li>Minimum requirements for each service tier</li>

        </ul>

        <p>

          Will be detailed in your specific service agreement provided at the time

          of subscription or enrollment.

        </p>

        <h3 style={{ fontWeight: "bold" }}>4. KS Quantitative Responsibilities:</h3>

        <p>

          KS Quantitative provides quantitative trading strategies, algorithmic

          solutions, and technical support. We execute trades on behalf of clients

          through our algorithmic systems in partnership with licensed brokerage firms.

          We do not handle client funds directly. Our investment advisory services

          include algorithmic strategy development, portfolio optimization, quantitative

          consulting, education and training, and direct fund management services.

          For managed investment services, appropriate regulatory frameworks apply.

        </p>

        <h3 style={{ fontWeight: "bold" }}>5. Client Responsibilities:</h3>

        <p>

          By proceeding, the Client acknowledges and agrees to:

        </p>

        <ul style={{ marginLeft: "1rem", marginBottom: "1rem" }}>

          <li>Review and agree to the specific service terms for your selected services</li>

          <li>Complete all required KYC (Know Your Customer) documentation</li>

          <li>Understand the risks associated with algorithmic trading and financial markets</li>

          <li>Comply with all applicable laws and regulations in their jurisdiction</li>

        </ul>

        <h3 style={{ fontWeight: "bold" }}>6. Risk Disclosure:</h3>

        <p>

          Trading in financial markets involves substantial risk of loss and is not

          suitable for all investors. Past performance is not indicative of future

          results. The Client acknowledges that they understand the risks involved

          and have the financial capacity to bear potential losses.

        </p>

        <h3 style={{ fontWeight: "bold" }}>7. Confidentiality:</h3>

        <p>

          Both parties agree to maintain strict confidentiality with respect to

          any proprietary trading strategies, algorithmic solutions, and client

          information shared during the course of this engagement.

        </p>

        <h3 style={{ fontWeight: "bold" }}>8. Governing Law:</h3>

        <p>

          This Service Agreement shall be governed by the laws of the Federal Republic

          of Nigeria. For PAM/MAM investment services, fund custody and regulatory

          compliance are governed by the laws and regulations of the respective

          broker's jurisdiction where client funds are held. Trading-related disputes

          for managed accounts are subject to the broker's dispute resolution

          procedures. Service-related disputes shall be resolved through negotiation

          or arbitration under Nigerian law.

        </p>

        <h3 style={{ fontWeight: "bold" }}>9. Important Notice:</h3>

        <p style={{ fontWeight: "bold", color: "#FFD700" }}>

          By proceeding, you acknowledge that specific service terms, conditions,

          fees, and policies will be provided for each service you select.

          This Service Agreement serves as the general framework for all KS

          Quantitative services.

        </p>

        <h3 style={{ fontWeight: "bold" }}>10. Acknowledgment:</h3>

        <p>

          By clicking "Proceed," the Client acknowledges that they have read,

          understood, and agree to the terms of this Service Agreement and

          consent to receiving KS Quantitative's services as selected.

        </p>


{/* Proceed Button */}
<a href="/register/select-service">
            <button
              type="button"
              className="mt-4 w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition duration-200"
            >
              Proceed to Service Selection
            </button>
          </a>


      </div>
      

    </>

  );

};



export default Agreement;


